import React from 'react'
import P from '../pages'
import { defaultMessages } from '../../../libs/i18n/default'
import { completeWizard } from '../actions'
import ButtonGroup from './ButtonGroup'
import Redirector from '../routes/Redirector'
import TrackableButton from './TrackableButton'
import ReactMarkdown from 'react-markdown'
import withDefaults from './withDefaults'

const Complete = ({ content, dispatch, page, user, intl: { formatMessage } }) => {
  const thisPage = P.COMPLETE_PAGE;

  const viewOrientation = (e) => {
    e.preventDefault()
    dispatch(completeWizard())
    .then(() => {
      window.location = '/orientation'
    })
  }

  const viewProfile = (e) => {
    e.preventDefault()
    dispatch(completeWizard())
    .then(() => {
      window.location = '/'
    })
  }

  return (
    <div id={page} className='profile'>
      <Redirector this_page={thisPage} page={page}/>

      <form>
        <div style={{paddingTop: '25%'}}>
          <ReactMarkdown source={content.pages.complete.title}/>
        </div>
        <div style={{paddingTop: '30px', paddingBottom: '10%'}}>
          <ReactMarkdown source={content.pages.complete.body}/>
          <p>
            <ReactMarkdown source={content.pages.complete.next_steps}/>
          </p>
        </div>
        <div className="row" style={{textAlign: 'center'}}>
          <TrackableButton
            type="submit"
            className='btn-default btn-lg'
            page={page}
            user={user}
            text={formatMessage(defaultMessages.clientGuestPagesCompleteButtonsViewDashboard)}
            onClick={viewProfile}/>
          { content.territory_code != "asc"  &&
            <TrackableButton
              type="submit"
              style={{marginLeft: '20px'}}
              className='btn-primary btn-lg'
              page={page}
              user={user}
              text={formatMessage(defaultMessages.clientGuestPagesCompleteButtonsOrientation)}
              onClick={viewOrientation}/>
          }
        </div>
        <ButtonGroup
          back={true}
          page={thisPage} />
      </form>
    </div>
  )
}

export default withDefaults(Complete);
